import {GetPdfByOfferIdApiArg} from '../api/types/onlineOfferTypes';

const PDF_MARGIN = '0px 0px 0px 0px';
const PDF_CONTENT_DISPOSITION = 'attachment';

type GetPdfQueryParamsInput = Pick<GetPdfByOfferIdApiArg, 'locale' | 'filename'>;

export function getPdfQueryParams(input: GetPdfQueryParamsInput) {
  return {
    lang: input.locale,
    filename: input.filename,
    margin: PDF_MARGIN,
    contentDisposition: PDF_CONTENT_DISPOSITION,
  };
}
